window.BOLD = window.BOLD || {}
BOLD.BMS = BOLD.BMS || {}
BOLD.BMS.extendOptions = function(option_product){
  //Prototype our useful function onto the OptionProduct constructor
  var option_product_prototype = Object.getPrototypeOf(option_product);
  option_product_prototype.getAllTheProductHandles = option_product_prototype.getAllTheProductHandles || function(){
      var optionHandles = [];
      for(var os=0; os < this.optionSets.length; os++){
        var option_set = this.optionSets[0];
        for(var o=0; o < option_set.options.length; o++){
          var option = option_set.options[o];
          for(var ov=0; ov < option.optionValues.length; ov++){
            var value = option.optionValues[ov];
            var duplicate = false;
            for(var h=0; h < optionHandles.length; h++){
              if(optionHandles[h]===value.productHandle){
                duplicate=true;
              }
            }
            if(value.productHandle && !duplicate){
              optionHandles.push(value.productHandle);
            }
          }
        }
      }
      return optionHandles;
    };
  option_product_prototype.getOptionByInternalName = option_product_prototype.getOptionByInternalName || function(name){
    if(!name){
      return null;
    }
    for(var os=0; os<this.optionSets.length; os++){
      var optionSet = this.optionSets[os];
      for(var o=0; o<optionSet.options.length; o++){
        var option = optionSet.options[o];
        if(option.internalName.toUpperCase() == name.toUpperCase()){
          return option;
        }
      }
    }
  };
  option_product_prototype.getOptionValuesByVariantId = option_product_prototype.getOptionValuesByVariantId || function(variant_id){
    this.variantIdLookup = this.variantIdLookup || {};
    if(this.variantIdLookup[variant_id]){
      return this.variantIdLookup[variant_id];
    }
    //Otherwise, set up variantIdLookup.
    //Since it involves looping through all the options anyways, save all of them in one swoop
    for(var os=0; os<this.optionSets.length; os++){
      var optionSet = this.optionSets[os];
      for(var o=0; o<optionSet.options.length; o++){
        var option = optionSet.options[o];
        for(var ov=0; ov<option.optionValues.length; ov++){
          var optionValue = option.optionValues[ov];

          if(optionValue.variantId){
            this.variantIdLookup[optionValue.variantId] = this.variantIdLookup[optionValue.variantId] || [];
            this.variantIdLookup[optionValue.variantId].push(optionValue);
          }
        }
      }
    }
    return this.variantIdLookup[variant_id];
  };
};
